export default import.meta.ROLLDOWN_FILE_URL_tdCEsyIO_gcxcDdQhZrkSQ